import React, { FC, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Flex } from 'rebass';
import { Field } from 'formik';

export const StyledInput = styled.textarea`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  flex: 1 0 auto;
  background: ${props =>
    props.disabled ? props.theme.bg.inactive : props.theme.bg.default};
  font-weight: 400;
  font-size: 16px;
  font-family: Poppins, sans-serif;
  border: 1px solid
    ${props =>
    props.disabled ? props.theme.bg.border : props.theme.bg.inactive};
  border-radius: 10px;
  padding: 18px 12px;
  box-shadow: none;
  &::-webkit-input-placeholder {
    color: ${props => props.theme.text.placeholder};
  }
  &:-moz-placeholder {
    color: ${props => props.theme.text.placeholder};
  }
  &:-ms-input-placeholder {
    color: ${props => props.theme.text.placeholder};
  }
  &:focus {
    border-color: ${props => props.theme.brand.default};
    outline: none;
  }
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
`;

const Input = (props:any) => {
  return (
    <Flex flex={1} style={props.containerStyle}>
      <StyledInput {...props.field} {...props} />
    </Flex>
  );
};

export const TextArea = (props: any) => {
  return <Field {...props} component={Input} />;
};

export const TextAreaNoForm = (props:any) => {
  return <Input {...props} />;
};

interface IAutoResizeTextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onHeightChange?: (height: number) => void;
  resizeTrigger?: number; 
}

export const AutoResizeTextarea:FC<IAutoResizeTextareaProps>=({value, onChange, onHeightChange, resizeTrigger, ...props})=> {
  const textareaRef = useRef<any>(null);

  const resize = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto'; // Reset height
      const newHeight = textarea.scrollHeight;
      textarea.style.height = `${newHeight}px`; // Set new height
      if (onHeightChange) {
        onHeightChange(newHeight);
      }
    }
  };

  useEffect(() => {
    const rAF = requestAnimationFrame(resize);
    return () => cancelAnimationFrame(rAF);
  }, []); // initial render

  useEffect(() => {
    resize();
  }, [value]);

  useEffect(() => {
    resize();
  }, [resizeTrigger]);

  return (
    <StyledInput
      ref={textareaRef}
      value={value}
      onChange={onChange}
      rows={1}
      {...props}
      style={{
        overflow: 'hidden',
        resize: 'none', // Optional: prevent manual resizing
        // background:props.disabled? ;
        ...props.style
      }}
    />
  );
}

export default TextArea;
